import { on_ready, is_elementor_edit } from 'js/utils';
import { retina_init } from 'js/retina';
import { toggle_height_init } from 'js/toggle_height_init';
import { load_swiper_check } from 'modules/carousel/load_swiper';
import { header_init } from 'modules/header/header';
import forms_init from 'modules/forms/forms';
import carousels_init from 'modules/carousel/carousel';
import footer_init from 'modules/footer/footer';
import nav_menu_init from 'modules/menu/nav/nav';
import { load_swiper_mobile } from 'modules/carousel/load_swiper_mobile';

// load global styles
import './main.scss';

on_ready(()=>{

    on_elementor_edit_screen();
    
    if( is_elementor_edit() ) return;
    
    // forms ui + gravityforms customizations
    // move outside of tasks queue, have issues with hooks registered late
    forms_init();
    
    load_swiper_mobile();

    load_swiper_check();

    header_init();

    nav_menu_init();

    carousels_init(); // swiper

    retina_init(); // @images

    toggle_height_init(); // toggle element height from 0 to default - for animating height

    // on_mobile();
    
    dynamic_load_init();
    
    document.dispatchEvent(new Event('after_main_init'));
});

function on_elementor_edit_screen(){
    footer_init();
}

// function on_mobile(){
//     if( window.innerWidth > 768 ) return;
// }

function dynamic_load_init(){

    // search popup: remove if not used
    if( document.querySelector('.search_popup_open') ) {
        import('modules/search/search_popup/init');
    }
    
    // burger / mobile menu: remove if not used
    if( document.querySelector('.slide_menu_open') ) {
        import('modules/menu/slide_menu/init');
    }

    // wishlist & compare: remove if not used
    if( document.querySelector('.compare_count') ||
        document.querySelector('.wishlist_count') ) {
        import('modules/save_items/init');
    }
    
    // cookie consent
    // if( !get_cookie('ff_cookie_consent') ) {
    //     import('modules/cookie_consent/simple/simple')
    // }
}